import React from 'react'
import ReactDOM from 'react-dom'
import classNames from 'classnames'
import Close from 'image/close-white.png'
import Icon from 'meinian-package/src/component/icon'
import util from 'meinian-package/src/utils/util'
import DownLoadImg from '../downloadImg'
import './index.less'

let percent1
let percent2

class PicturePreview extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      viewImgIndex: props.viewImgIndex,
      src: props.src,
      fittingData: props.fittingData,
      zoomRatio: props.fittingData ? 0.75 : 1, // 图片缩放比例
      rotate: 0, // 旋转角度
      percentTipsVisible: false, // 缩放百分比提示
      percentTips: false,
      drag: false,
      position: {
        x: 0,
        y: 0
      },
    }
    this.mouseWheelScroll = this.mouseWheelScroll.bind(this)
  }

  componentDidMount() {
    // 初始化百分数
    this.initPercent()
    // 绑定滚轮事件
    this.bindMouseWheelEvent()
  }

  // 解绑滚轮事件
  componentWillUnmount() {
    this.unbindMouseWheelEvent()
  }

  // 下载图片
  downloadImg = () => {
    DownLoadImg.show(this.state.fittingData)
  }

  // eslint-disable-next-line react/no-unused-class-component-methods
  percentageHidden() {
    let { percentTipsVisible, percentTips } = this.state
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const that = this
    percent1 = setTimeout(() => {
      percentTipsVisible = true
      that.setState({ percentTipsVisible }, () => {
        percent2 = setTimeout(() => {
          percentTipsVisible = false
          percentTips = true
          that.setState({ percentTipsVisible, percentTips })
        }, 3000)
      })
    }, 1500)
  }

  // 初始化百分比设置
  initPercent() {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const that = this
    let { percentTipsVisible, percentTips } = that.state

    clearTimeout(percent2)
    clearTimeout(percent1)

    percentTipsVisible = false
    percentTips = false
    that.setState({ percentTipsVisible, percentTips }, () => that.percentageHidden())
  }

  // 点击关闭按钮关闭弹窗
  closePicture(e) {
    e.stopPropagation()
    this.componentWillUnmount()
    const { closeClick, callback } = this.props
    closeClick && closeClick()
    callback && callback(false)
  }

  // 旋转图片
  turnRight(e) {
    e.stopPropagation()
    const { rotate } = this.state
    const _rotate = rotate + 90
    this.setState({ rotate: _rotate })
  }

  // 缩放图片，100%查看
  zoomImage(type = '') {
    let { zoomRatio } = this.state
    const ratio = 1.25
    const pic = this.pictureEl
    this.initPercent()
    switch (type) {
      case 'enlarge':
        zoomRatio *= ratio
        break
      case 'narrow':
        zoomRatio /= ratio
        break
      default:
        zoomRatio = 1
        break
    }
    if (zoomRatio >= 10) {
      zoomRatio = 10
    }

    if (zoomRatio <= 0.2) {
      zoomRatio = 0.2
    }

    this.setState({ zoomRatio }, () => {
      if (this.state.zoomRatio <= 1) {
        pic.onmousedown = null
      }
    })
  }

  mouseMove(e) {
    e.preventDefault()
    if (this.state.drag) {
      this.setState({
        position: {
          x: e.clientX - this.beginPosition.x,
          y: e.clientY - this.beginPosition.y
        }
      })
    }
  }

  mouseDown(e) {
    e.preventDefault()
    const { x, y } = this.state.position
    this.beginPosition = {
      x: e.clientX - x,
      y: e.clientY - y
    }
    this.setState({ drag: true })
  }

  mouseUp(e) {
    e.preventDefault()
    this.setState({ drag: false })
  }

  // 滚轮事件
  mouseWheelScroll(e) {
    e.preventDefault()
    const _delta = parseInt((e.wheelDelta || -e.detail), 10)

    _delta > 0 ? this.zoomImage('enlarge') : this.zoomImage('narrow')
  }

  // 绑定鼠标滚轮事件
  bindMouseWheelEvent() {
    const MOUSE_WHEEL_EVENT = navigator.userAgent.indexOf('Firefox') > -1 ? 'DOMMouseScroll' : 'mousewheel'

    if (document.attachEvent) {
      document.body.attachEvent(`on${MOUSE_WHEEL_EVENT}`, this.mouseWheelScroll)
    } else if (document.addEventListener) {
      document.body.addEventListener(MOUSE_WHEEL_EVENT, this.mouseWheelScroll, false)
    }
  }

  // 解除鼠标滚轮事件
  unbindMouseWheelEvent() {
    const MOUSE_WHEEL_EVENT = navigator.userAgent.indexOf('Firefox') > -1 ? 'DOMMouseScroll' : 'mousewheel'

    if (document.attachEvent) {
      document.body.detachEvent(`on${MOUSE_WHEEL_EVENT}`, this.mouseWheelScroll)
    } else if (document.addEventListener) {
      document.body.removeEventListener(MOUSE_WHEEL_EVENT, this.mouseWheelScroll)
    }
  }

  viewNextBlog(step, e) {
    const { viewImgIndex } = this.state
    e.stopPropagation()
    this.setState({ viewImgIndex: viewImgIndex + step }, () => {
      const current = this.props.data[viewImgIndex]
      this.setState({
        src: current.mainUrl,
        fittingData: current
      })
    })
  }

  renderArraw() {
    const { data } = this.props
    const { viewImgIndex } = this.state
    return (<>
      <div onClick={this.viewNextBlog.bind(this, -1)} style={{ display: viewImgIndex > 0 ? 'block' : 'none' }} className="pre-turn-item-arrow pre-turn-item-arrow-left">
        <Icon type="m-Vxing_you" style={{ width: '37px', height: '37px' }} />
      </div>
      <div onClick={this.viewNextBlog.bind(this, 1)} style={{ display: viewImgIndex < data.length - 1 ? 'block' : 'none' }} className="pre-turn-item-arrow pre-turn-item-arrow-right">
        <Icon type="m-Vxing_you" style={{ width: '37px', height: '37px' }} />
      </div>
    </>
    )
  }

  render() {
    const { fittingData } = this.state
    const { src, zoomRatio, rotate, percentTipsVisible, percentTips, position: { x, y }, drag } = this.state
    const style = {
      transform: `translate(-50%, -50%) rotate(${rotate}deg) scale(${zoomRatio})`,
      top: '50%',
      left: '50%',
      marginLeft: `${x}px`,
      marginTop: `${y}px`,
      userSelect: 'none'
    }
    if (!drag) {
      style.transition = 'all .2s linear'
    }
    const ratio = Math.round(zoomRatio * 100)
    return (
      <div className="picturePreview-container">
        <span className="icon-close-collect" onClick={this.closePicture.bind(this)}>
          <img className="ins-blog-imgs-detail-close" src={Close} alt="" />
        </span>
        <div className="picturePreview-container-up" onClick={this.closePicture.bind(this)}>
          {fittingData && this.renderArraw()}
          <img
            ref={el => this.pictureEl = el}
            src={src}
            className="picturePreview-pic no-weidth"
            style={style}
            onMouseMove={this.mouseMove.bind(this)}
            onMouseDown={this.mouseDown.bind(this)}
            onMouseUp={this.mouseUp.bind(this)}
            onClick={e => e.stopPropagation()}
            onContextMenu={e => (e.preventDefault ? e.preventDefault() : (e.returnValue = false))}
          />
          <div
            // eslint-disable-next-line react/no-string-refs
            ref="percentage"
            className={classNames('picturePreview-percentage', {
              'picturePreview-hidden': percentTipsVisible,
              'no-percentage': percentTips
            })}
            onClick={e => e.stopPropagation()}
          >
            {ratio}
            &nbsp;%
          </div>
        </div>
        <div className="mn-picturePreview-container-down">
          <span onClick={this.zoomImage.bind(this)}><Icon style={{ color: '#fff' }} type="m-shijidaxiao" title="100%显示" /></span>
          <span onClick={this.zoomImage.bind(this, 'enlarge')}><Icon style={{ color: '#fff' }} type="m-fangda" title="放大" /></span>
          <span onClick={this.zoomImage.bind(this, 'narrow')}><Icon style={{ color: '#fff' }} type="m-suoxiao" title="缩小" /></span>
          {
            fittingData
              ? <span onClick={this.downloadImg.bind(this)}><Icon type="m-xiazai" style={{ color: '#fff' }} title="下载" /></span>
              : <><span onClick={this.turnRight.bind(this)}><Icon type="m-shuaxin" style={{ color: '#fff' }} title="向右旋转" /></span>
                <span onClick={() => util.downloadOssImageByUrl(this.state.src)}><Icon type="m-xiazai" style={{ color: '#fff' }} title="下载" /></span></>
          }
        </div>
      </div>
    )
  }
}
let div = document.createElement('div')
function destory(resolve, reject, val) {
  const unmountResult = ReactDOM.unmountComponentAtNode(div)
  if (unmountResult && div.parentNode) {
    div.parentNode.removeChild(div)
    resolve(val)
  }
}

export default {
  show(picInfo, callback) {
    return new Promise((resolve, reject) => {
      div = document.createElement('div')
      div.id = 'picture-mask-wrapper'
      document.body.appendChild(div)
      ReactDOM.render(<PicturePreview {...picInfo} callback={callback} closeClick={destory.bind(this, resolve, reject)} />, div)
    })
  },
}
